import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  ListItem,
  Button,
  Flex,
  UnorderedList,
  Card,
  CardBody,
  CardFooter,
  Center,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  basic_yearly,
  expanded_yearly,
  basic_monthly,
  expanded_monthly,
} from "../utils/config";

const Pricing = ({ showTitle, handleClick, widthNew }) => {
  const [isActiveMonthlyPlan, setIsActiveMonthlyPlan] = useState(true);
  const [isActiveYearlyPlan, setIsActiveYearlyPlan] = useState(false);

  const navigate = useNavigate();

  const handleDemoClick = () => {
    navigate("/contactus");
  };

  const userold = useSelector((state) => state.user);
  const currentUser = userold?.currentUser;
  const currentEmployee = currentUser?.employees[userold?.currentCompany];
  const roleName = currentEmployee?.rolename;

  const divStyle = {
    // width: widthNew ? "250px" : "450px",
    padding: "0px",
  };

  const pricingDatamonthly = [
    {
      title: "Basic",
      heading: "Simple & Effective.",
      name: "Designed for teams new to goal-setting with OKRs",
      price_id: basic_monthly,
      price: "$5",
      features: [
        "Customize goals & OKRs",
        "TouchBase",
        "Insights & Analytics",
        "Collaboration features",
        "Integrations (e.g., Trello, Jira, Asana)",
        "Up To 5 Team members",
      ],
    },
    {
      title: "Expanded",
      heading: "Customizable. Scalable. Intelligent.",
      name: "Best option for teams growing and scaling execution",
      description: "",
      price_id: expanded_monthly,
      price: "$10",
      features: [
        "Everything from Basic",
        "Exportable reports (PPT/PDF)",
        "Advanced analytics",
        "AI-supported continuous improvement",
        "AI-generated executive summaries",
        "Expanded support", 
        "Up To 25 team members",
      ],
    },
    {
      title: "Premium",
      heading: "Comprehensive. Flexible. Enterprise-Ready.",
      name: "Built for advanced control, security and support needs",
      description: "Contact us",
      price: "",
      features: [
        "Everything from Basic + Expanded",
        "SSO (SAML)",
        "Custom data integrations (e.g., CRM)",
        "Flexible team hierarchy",
        "Dedicated account manager",
        "Professional OKR coaching",
        "100+ members",
      ],
      footer: "",
      demoButton: true,
    },
  ];

  const pricingDataAnually = [
    {
      title: "Basic",
      heading: "Simple & Effective.",
      name: "Designed for teams new to goal-setting with OKRs",
      price_id: basic_yearly,
      price: "$4",
      features: [
        "Customize goals & OKRs",
        "TouchBase",
        "Insights & Analytics",
        "Collaboration features",
        "Integrations (e.g., Trello, Jira, Asana)",
        "Up To 5 Team members",
      ],
    },
    {
      title: "Expanded",
      heading: "Customizable. Scalable. Intelligent.",
      name: "Best option for teams growing and scaling execution",
      description: "",
      price_id: expanded_yearly,
      price: "$8",
      features: [
        "Everything from Basic",
        "Exportable reports (PPT/PDF)",
        "Advanced analytics",
        "AI-supported continuous improvement",
        "AI-generated executive summaries",
        "Expanded support", 
        "Up To 25 team members",
      ],
    },
    {
      title: "Premium",
      heading: "Comprehensive. Flexible. Enterprise-Ready.",
      name: "Built for advanced control, security and support needs",
      description: "Contact us",
      // price: "$120",
      features: [
        "Everything from Basic + Expanded",
        "SSO (SAML)",
        "Custom data integrations (e.g., CRM)",
        "Flexible team hierarchy",
        "Dedicated account manager",
        "Professional OKR coaching",
        "100+ members",
      ],
      demoButton: true,
    },
  ];

  return (
    <Box id="pricing" className="md:px-3 py-10 overflow-x-hidden">
      {showTitle && (
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "4xl" }}
          color={"#14285a"}
          textAlign={"center"}
        >
          Plans
        </Heading>
      )}
      <Box display={"flex"} justifyContent={"center"} mb={"5"} mt={3}>
        <Flex
          borderRadius={"full"}
          bg={"#ECECEC"}
          p={"8px 10px"}
          justifyContent={"center"}
          gap={2}
        >
          <Box
            borderRadius={"full"}
            bg={isActiveMonthlyPlan ? "#F27E0D" : "#ECECEC"}
            p={"8px 25px"}
            cursor={"pointer"}
            black={"#212121"}
            onClick={() => {
              setIsActiveMonthlyPlan(true);
              setIsActiveYearlyPlan(false);
            }}
          >
            <Text color={isActiveMonthlyPlan ? "#FFFFFF" : "#000000"}>
              Monthly
            </Text>
          </Box>
          <Box
            borderRadius={"full"}
            bg={isActiveYearlyPlan ? "#F27E0D" : "#ECECEC"}
            p={"8px 25px"}
            cursor={"pointer"}
            onClick={() => {
              setIsActiveYearlyPlan(true);
              setIsActiveMonthlyPlan(false);
            }}
          >
            <Text color={isActiveYearlyPlan ? "#FFFFFF" : "#000000"}>
              Yearly
            </Text>
          </Box>
        </Flex>
      </Box>
      <Box display="flex" justifyContent="center" gap="90px" flexWrap="wrap">
        {isActiveMonthlyPlan &&
          pricingDatamonthly?.map((plan, index) => (
            <PricingCard
              key={index}
              title={plan.title}
              divStyle={divStyle}
              heading={plan.heading}
              name={plan.name}
              price={plan.price}
              features={plan.features}
              description={plan.description}
              demoButton={plan.demoButton}
              footer={plan.footer}
              handleDemoClick={handleDemoClick}
              planType="monthly"
              showTitle={showTitle}
              handleClick={() => {
                handleClick(plan);
              }}
              roleName={roleName}
            />
          ))}

        {isActiveYearlyPlan &&
          pricingDataAnually?.map((plan, index) => (
            <PricingCard
              key={index}
              title={plan.title}
              divStyle={divStyle}
              heading={plan.heading}
              name={plan.name}
              price={plan.price}
              features={plan.features}
              description={plan.description}
              footer={plan.footer}
              demoButton={plan.demoButton}
              handleDemoClick={handleDemoClick}
              planType="yearly"
              showTitle={showTitle}
              handleClick={() => {
                handleClick(plan);
              }}
              roleName={roleName}
            />
          ))}
      </Box>
    </Box>
  );
};

const PricingCard = ({
  title,
  heading,
  name,
  price,
  features,
  planType,
  demoButton,
  footer,
  description,
  handleDemoClick,
  showTitle,
  handleClick,
  divStyle,
  roleName,
}) => (
  <div className="md:px-6  py-10 flex justify-center " style={{...divStyle, width: "360px"}}>
    <Card className="shadow-2xl w-4/5 flex justify-center md:w-11/12 md:h-full p-2 transition-transform transform-gpu hover:shadow-md ">
      <CardBody>
        <Heading as="h3" fontSize="3xl" mb={4} textAlign={"center"}>
          {title}
        </Heading>

        <Text as="h5" fontWeight={"Bold"} fontSize="xl" textAlign={"center"}>
          {heading}
        </Text>
        <Text
          as="h5"
          fontSize="lg"
          mb={4}
          mt={4}
          textAlign={"center"}
          color={"#F7AD18"}
        >
          {name}
        </Text>
        {!demoButton && (
          <Text
            fontSize="4xl"
            fontWeight="bold"
            mb={4}
            textAlign={"center"}
            color={"#F7AD18"}
          >
            {price}
            <Flex direction="column" align="center" justify="center">
              <Text as="span" color="gray.500" fontSize="md">
                User/Month
              </Text>
              {planType === "yearly" && (
                <Text as="span" color="gray.400" fontSize="sm" mt={1}>
                  (billed annually)
                </Text>
              )}
            </Flex>
          </Text>
        )}
        {demoButton && (
          <Text
            fontSize="4xl"
            fontWeight="bold"
            mb={4}
            textAlign={"center"}
            color={"#F7AD18"}
            cursor="pointer"
            onClick={handleDemoClick}
            _hover={{ color: "#F27E0D" }}
          >
            {description}
          </Text>
        )}
        <UnorderedList className="mb-2">
          {features?.map((feature, index) => {
            const [title, description] = feature.split(":");
            return (
              <ListItem key={index} fontSize="md" mt={2} color="gray.500">
                <Text as="span" fontWeight="bold">
                  {title}
                  {description && ":"}
                </Text>{" "}
                <Text className="text-md">
                {description?.trim()}
                </Text>
              </ListItem>
            );
          })}
        </UnorderedList>
        <Text  color="gray.500" className="mt-4 text-md ">
          {footer}
        </Text>
      </CardBody>
      {roleName === "Admin" && (
        <CardFooter
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {!demoButton ? (
            <>
              {showTitle ? (
                <Link to="/Register">
                  <Button
                    colorScheme="#F27E0D"
                    w="full"
                    px={6}
                    borderRadius="20px"
                    bgColor="#F27E0D"
                    className="hover:bg-button-hover transition-all"
                  >
                    Subscribe
                  </Button>
                </Link>
              ) : (
                <Box>
                  <Button
                    colorScheme="#F27E0D"
                    w="full"
                    px={6}
                    borderRadius="20px"
                    bgColor="#F27E0D"
                    className="hover:bg-button-hover transition-all"
                    onClick={handleClick}
                  >
                    Subscribe
                  </Button>
                </Box>
              )}
            </>
          ) : (
            <Box>
              <Button
                colorScheme="#F27E0D"
                w="full"
                px={6}
                borderRadius="20px"
                bgColor="#F27E0D"
                className="hover:bg-button-hover transition-all"
                onClick={handleDemoClick}
              >
                Book A Demo <ArrowForwardIcon className="ml-1" />
              </Button>
            </Box>
          )}
        </CardFooter>
      )}
    </Card>
  </div>
);

export default Pricing;
